module.exports = __webpack_public_path__ + "static/img/model-2.b0c9a34.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phoneHomePage/model-2.gif
// module id = ewDl
// module chunks = 0